import { Form } from "devextreme-react";
import React, { useCallback, useEffect, useState } from "react";
import { Label, SimpleItem } from "devextreme-react/form";
import useAxiosPrivate, { axiosHrPrivate } from "../../../../api/useAxios";
import notify from "devextreme/ui/notify";
import { useLookupGroup } from "../../../../contexts/lookup-group-context";
import { useAuth } from "../../../../contexts/auth";
import { lookupGroups } from "../../../../utils/lookup-groups.ts";


export default function Education({ employeeId }) {
    const [formData, setFormData] = useState({
        employeeId: employeeId,
        educationStatusId: "",
        id: ""
    })
    
    const [educationStatusList, setEducationStatusList] = useState()
    const {getLookupData} = useLookupGroup()
    const {activeLanguage} = useAuth()
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)


    const saveData = () => {
        const data = {}
        data.values = JSON.stringify(formData)

        if (formData.id)
            data.key = formData.id

        const axiosOptions = {
            method: formData.id ? "put" : "post",
            url: "/api/EmployeeEducation/FormData",
            data: data
        }

        axiosPrivate(axiosOptions)
            .then((response) => {
                if (response?.status === 201) {
                    if (!formData.id)
                        if (response.data?.data?.id) {
                            setFormData((prev) => {
                                return { ...prev, id: response.data.data.id }
                            }
                            )
                        }
                }
                if (response?.status === 201 || response?.status === 200) {
                    notify("İşlem başarılı", "success")
                }
            })
            .catch((error) => {
                notify("İşlem başarız. ", error)
                loadData()
            })
    }

    const loadData = () => {
        axiosPrivate.get(`/api/EmployeeEducation/${employeeId}`)
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.data)
                        setFormData(response.data.data)
                }
            })
            .catch((error) => { console.log(error) })
    }

    useEffect(() => {
        loadData()
    }, [employeeId])

    const educationStatusOptions = useCallback({
        items: educationStatusList,
        valueExpr: "id",
        displayExpr: "text",
    }, [educationStatusList])

    const handleFieldDataChanged = (e) => {
        if (e?.dataField === "educationStatusId") {
            saveData()
        }
    }

    useEffect(()=>{
        getLookupData(lookupGroups.educationStatus).then(response => setEducationStatusList(response))
    },[activeLanguage])

    if (!employeeId)
        return undefined;

    return (
        <React.Fragment>
            <Form
                width={300}
                formData={formData}
                onFieldDataChanged={handleFieldDataChanged}
            >
                <SimpleItem dataField="educationStatusId" editorType="dxSelectBox" editorOptions={educationStatusOptions} >
                    <Label text="Eğitim Durumu" />
                </SimpleItem>

            </Form>

        </React.Fragment>
    )
}